import React from 'react';
import styled from 'styled-components';
import { UnstyledButton } from './Button';
import { Icon } from '../Icon';
import { OnClickFocusWrapper } from '../UtilityWrappers';
const StyledButton = styled(UnstyledButton) `
  background: white;
  border-radius: ${({ isCircular }) => (isCircular ? '50%' : 'none')};
  min-height: 45px;
  min-width: 45px;
`;
const StyledIcon = styled(Icon) `
  color: ${({ theme }) => theme.primaryBlack};
  font-size: ${({ iconSize }) => (iconSize ? `${iconSize}px` : '45px')};
  position: relative;
  margin: auto;
  bottom: -1px;
`;
const CloseButton = ({ onClick, isCircular, iconSize }) => {
    return (React.createElement(OnClickFocusWrapper, null,
        React.createElement(StyledButton, { onClick: onClick, type: "button", isCircular: isCircular },
            React.createElement(StyledIcon, { iconSize: iconSize }, "close"))));
};
export { CloseButton };
